import Vue from 'vue'

const { LMap, LTileLayer, LControl, LControlLayers, LControlZoom,
    LMarker, LCircle, LPopup, LControlAttribution } = require('vue2-leaflet')

const LDrawToolbar = require('vue2-leaflet-draw-toolbar').default

// Register global components
Vue.component('l-map', LMap)
Vue.component('l-tile-layer', LTileLayer)
Vue.component('l-control', LControl)
Vue.component('l-control-layers', LControlLayers)
Vue.component('l-control-zoom', LControlZoom)
Vue.component('l-marker', LMarker)
Vue.component('l-circle', LCircle)
Vue.component('l-popup', LPopup)
Vue.component('l-control-attribution', LControlAttribution)
Vue.component('l-draw-toolbar', LDrawToolbar)